
export const supportedLanguages = ["de", "en", "fr", "it"];

export const getGenderTextKey = (gender: number, shortText: boolean = false) : string => {
  var prefix = shortText ? "gender.short" : "gender";
  var textKey = "";
  switch (gender) {
    case 0:
      textKey = prefix + ".male";
      break;

    case 1:
      textKey = prefix + ".female";
      break;

    case 2:
      textKey = prefix + ".gender.other";
      break;

    default:
      textKey = "";
      break;
  }

  return textKey;
}
